import { render, staticRenderFns } from "./KBack.vue?vue&type=template&id=e010631e&"
import script from "./KBack.vue?vue&type=script&lang=js&"
export * from "./KBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports